module.exports = {"StatusCode":200,"Payload":[{"websites":[]}]}


//////////////////
// WEBPACK FOOTER
// ./src/payloads/aws/lambda/mocks/updateSubUser.json
// module id = udmE
// module chunks = 0